export default __webpack_public_path__ + "5fd348cd7c6ba778c66e9098a98fdb4a.png";